import React from 'react';
import FlipCard from './FlipCard';
import sharp from '../images/card/Sharp-Industrial.gif'
import leptop from '../images/card/laptop-db.gif'
import rocky from '../images/card/rocky-fitness.gif'
import pure from '../images/card/pure-pd.gif'
import green from '../images/card/green-convention.gif'
import flim from '../images/card/Filmmaking-gadgets-1.gif'

const MyProjects = () => {
    const sharpData = {
        name:"Sharp-Industrial",
        title: "(Manufacturer Industry website)",
    }
    const laptpData = {
        name:"Laptop-DB",
        title: "(Warehouse Management Website)",
    }
    const rockyData = {
        name:"Rocky-Fitness",
        title: "(Personal fitness Trainer webapp. )",
    }
    const pureData = {
        name:"PurePD",
        title: "(Product analysis Website)",
    }
    const greenData = {
        name:" Green-Convention-Center",
        title: "(Convention Center booking website)",
    }
    const filmData = {
        name:"Filmaking-Gadgets",
        title: "(Gadgets Online Shop)",
    }
    return (
        <div id='protfolio'>

            <h1  className='text-center my-20 text-4xl font-bold text-white mt-32'>My Awesome <span className='text-neutral' >Projects</span></h1>
            
            <div  className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 ">
                <FlipCard data={sharpData}  img={sharp} ></FlipCard>
                <FlipCard data={laptpData} img={leptop} ></FlipCard>
                <FlipCard data={rockyData} img={rocky} ></FlipCard>
                <FlipCard data={pureData} img={pure} ></FlipCard>
                <FlipCard data={greenData} img={green} ></FlipCard>
                <FlipCard data={filmData} img={flim} ></FlipCard>
            </div>



        </div>
    );
};

export default MyProjects;